// jQuery を最初にグローバル公開する。
// ESM の import は hoist されるため、エントリポイント内に直接
// 「import jquery → window 代入 → プラグイン import」と書くと
// 代入より先にプラグインが実行されてしまう。専用モジュールに分離して
// import 順で実行順を保証する。
import jquery from "jquery";

window.jQuery = window.$ = jquery;

// jquery-ujs が持っていた CSRF トークン付与の代替。
// 外部ドメインへの送信でトークンを漏らさないよう、jquery-ujs と同じく crossDomain は除外する。
window.jQuery.ajaxSetup({
  beforeSend: function (xhr, settings) {
    if (settings.crossDomain) return;
    if (settings.type && settings.type.toUpperCase() === "GET") return;
    var token = document.querySelector('meta[name="csrf-token"]');
    if (token) xhr.setRequestHeader("X-CSRF-Token", token.getAttribute("content"));
  }
});
